<div
  class="absolute top-1/2 right-1 flex -translate-y-1/2 items-center justify-center space-x-1 rounded-md border border-zinc-300/20 bg-zinc-50 p-0.5 shadow-sm dark:bg-zinc-800">
  @for (action of actions(); track action) {
    <div>
      <button
        #actionButton
        tabindex="-1"
        (click)="onActionClick($event, action)"
        class="flex h-4 w-4 cursor-pointer items-center justify-center rounded-[calc(var(--radius-md)-var(--spacing)/2)] p-0.5 hover:bg-zinc-300 dark:hover:bg-zinc-900">
        <i class="text-zinc-500 dark:text-zinc-200" [class]="getIconClasses(action)"></i>
      </button>
      <app-tooltip
        [target]="actionButton"
        [content]="getTooltipKey(action) | translate"
        [position]="'top-start'" />
    </div>
  }
</div>
